// UI preferences: theme + a lightweight toast queue.
import { create } from 'zustand';

export type Theme = 'dark' | 'light';

export interface Toast {
  id: number;
  kind: 'success' | 'error' | 'info';
  message: string;
}

interface UiState {
  theme: Theme;
  toasts: Toast[];
  toggleTheme: () => void;
  pushToast: (kind: Toast['kind'], message: string) => void;
  dismissToast: (id: number) => void;
}

let toastId = 0;

export const useUiStore = create<UiState>((set) => ({
  theme: 'dark',
  toasts: [],
  toggleTheme: () =>
    set((s) => ({ theme: s.theme === 'dark' ? 'light' : 'dark' })),
  pushToast: (kind, message) =>
    set((s) => ({ toasts: [...s.toasts, { id: ++toastId, kind, message }] })),
  dismissToast: (id) =>
    set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));
